<form *ngIf="options.length > 0" [formGroup]="mappingForm" class="flex flex-col w-full" (ngSubmit)="onSubmit()">
  <h2 class="text-2xl text-center">Transaction Mapping</h2>
  <p class=" text-sm text-center my-8 mx-2">Now that your bank or credit card statement is uploaded,
    you'll need to map out the transactions.
    This simply means that you match each column of information from your CSV
    file to the three categories of information we need to import these transactions to
    your cash flow. After you've mapped the Name, Value, and Date, you can click 'Save'
    and you'll be brought to your cash flow.</p>
  <tandem-form-select
    [tooltipText]="nameText"
    inputId="name"
    label="Name"
    [controlName]="'name'"
    [form]="mappingForm"
    [options]="options">
  </tandem-form-select>
  <tandem-form-select
    [tooltipText]="valueText"
    inputId="value"
    label="Value"
    [controlName]="'value'"
    [form]="mappingForm"
    [options]="options">
  </tandem-form-select>
  <tandem-form-select
    [tooltipText]="dateText"
    inputId="date"
    label="Date"
    [controlName]="'date'"
    [form]="mappingForm"
    [options]="options">
  </tandem-form-select>
  <tandem-form-checkbox
    [tooltipText]="invertAmountText"
    [form]="mappingForm"
    controlName="invertAmounts"
    [label]="'Invert Amounts'"
    [inputId]="'invertAmounts'">
  </tandem-form-checkbox>

  <h5 *ngIf="!!errorMessage" class="my-8 text-red w-full text-center">{{errorMessage}}</h5>
  <div class="mt-8 flex flex-row justify-center gap-4">
    <tandem-button theme="outline" [onClick]="onCancel.bind(this)">Cancel</tandem-button>
    <tandem-button type="submit" theme="solid" [onClick]="onSubmit.bind(this)" [disabled]="mappingForm.invalid">Save</tandem-button>
  </div>
</form>
